import p1_img from "./product_1.png";
import p2_img from "./product_2.png";
import p3_img from "./product_3.png";
import p4_img from "./product_4.png";
import p5_img from "./product_5.png";
import p6_img from "./product_6.png";
import p7_img from "./product_7.png";
import p8_img from "./product_8.png";
import p9_img from "./product_9.png";
import p10_img from "./product_10.png";
import p11_img from "./product_11.png";
import p12_img from "./product_12.png";
import p13_img from "./product_13.png";
import p14_img from "./product_14.png";
import p15_img from "./product_15.png";
import p16_img from "./product_16.png";
import p17_img from "./product_17.png";
import p18_img from "./product_18.png";
import p19_img from "./product_19.png";
import p20_img from "./product_20.png";
import p21_img from "./product_21.png";
import p22_img from "./product_22.png";
import p23_img from "./product_23.png";
import p24_img from "./product_24.png";
import p25_img from "./product_25.png";
import p26_img from "./product_26.png";
import p27_img from "./product_27.png";
import p28_img from "./product_28.png";
import p29_img from "./product_29.png";
import p30_img from "./product_30.png";
import p31_img from "./product_31.png";
import p32_img from "./product_32.png";
import p33_img from "./product_33.png";
import p34_img from "./product_34.png";
import p35_img from "./product_35.png";
import p36_img from "./product_36.png";

let all_product = [
  {
    id: 1,
    name: "Butter Pot Mercury Finish",
    category: "prod",
    image: p1_img,
    new_price: 25.0,
    old_price: 35.0,
  },
  {
    id: 2,
    name: "Candle Votive",
    category: "prod",
    image: p2_img,
    new_price: 25.0,
    old_price: 30.5,
  },
  {
    id: 3,
    name: "Glass Jar with Wooden Lid",
    category: "prod",
    image: p3_img,
    new_price: 65.0,
    old_price: 80.5,
  },
  {
    id: 4,
    name: "Yankee Jar",
    category: "prod",
    image: p4_img,
    new_price: 22.0,
    old_price: 30.0,
  },
  {
    id: 5,
    name: "Square Glass Jar",
    category: "prod",
    image: p5_img,
    new_price: 32.0,
    old_price: 40.5,
  },
  {
    id: 6,
    name: "Square Glass Jar with Heart",
    category: "prod",
    image: p6_img,
    new_price: 52.0,
    old_price: 60.5,
  },
  {
    id: 7,
    name: "Screwed Glass Jar",
    category: "prod",
    image: p7_img,
    new_price: 35.0,
    old_price: 50.0,
  },
  {
    id: 8,
    name: "Murphy Cup Frosted + Color",
    category: "prod",
    image: p8_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 9,
    name: "Design Glass Jar Mercury+Gold",
    category: "prod",
    image: p9_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 10,
    name: "Glass Bell Jar with Color",
    category: "prod",
    image: p10_img,
    new_price: 99.0,
    old_price: 120.5,
  },
  {
    id: 11,
    name: "Glass Bell Jar Mercury+Gold (Set)",
    category: "prod",
    image: p11_img,
    new_price: 699.0,
    old_price: 820.5,
  },
  {
    id: 12,
    name: "Butter Pot ",
    category: "prod",
    image: p12_img,
    new_price: 20.0,
    old_price: 25.5,
  },
  {
    id: 13,
    name: "Diamond Cut Candy Jar with Color",
    category: "prod",
    image: p13_img,
    new_price: 99.0,
    old_price: 120.5,
  },
  {
    id: 14,
    name: "Laisun ",
    category: "prod",
    image: p14_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 15,
    name: "Dry Fruit Jar",
    category: "prod",
    image: p15_img,
    new_price: 99.0,
    old_price: 120.5,
  },
  {
    id: 16,
    name: "Diamond Cut Candy Jar (Transparent)",
    category: "prod",
    image: p16_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 17,
    name: "Diamond Cut Candy Jar (Metalizing)",
    category: "prod",
    image: p17_img,
    new_price: 149.0,
    old_price: 200.5,
  },
  {
    id: 18,
    name: "Black Square Glass Jar (300ml)",
    category: "prod",
    image: p18_img,
    new_price: 90.0,
    old_price: 120.5,
  },
  {
    id: 19,
    name: "Square Glass Jar (Mercury+Color)",
    category: "prod",
    image: p19_img,
    new_price: 59.0,
    old_price: 80.5,
  },
  {
    id: 20,
    name: "Frosted Glass Jar with color",
    category: "prod",
    image: p20_img,
    new_price: 55.0,
    old_price: 80.5,
  },
  {
    id: 21,
    name: "Lota + Mercury Finish",
    category: "prod",
    image: p21_img,
    new_price: 100.0,
    old_price: 120.5,
  },
  {
    id: 22,
    name: "",
    category: "prod",
    image: p22_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 23,
    name: "prod Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "prod",
    image: p23_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 24,
    name: "prod Green Solid Zippered Full-Zip Slim Fit Bomber Jacket",
    category: "prod",
    image: p24_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 25,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p25_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 26,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p26_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 27,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p27_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 28,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p28_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 29,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p29_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 30,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p30_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 31,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p31_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 32,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p32_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 33,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p33_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 34,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p34_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 35,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p35_img,
    new_price: 85.0,
    old_price: 120.5,
  },
  {
    id: 36,
    name: "Boys Orange Colourblocked Hooded Sweatshirt",
    category: "prod",
    image: p36_img,
    new_price: 85.0,
    old_price: 120.5,
  },
];

export default all_product;
